/*
 * @Author: zwcong
 * @Description:
 * @Date: 2021-12-07 17:25:44
 * @LastEditTime: 2022-03-09 11:56:29
 * @FilePath: /app-teacher-h5/src/service/login/index.js
 */
import http from '../http'
import url from './index-url'
const { get, post } = http

export default {
  groupDetailsList(data) {
    return get(url.groupDetailsList(data), {
      ...data
    })
  },
  getSubjectGrade(data) {
    return get(url.getSubjectGrade(data), {
      ...data
    })
  },
  copyGroupPlan(data) {
    return post(url.copyGroupPlan(data), {
      ...data
    })
  },
  deletePlan(data) {
    return post(url.deletePlan(data), {
      ...data
    })
  },
  classBegin(data) {
    return post(url.classBegin(data), {
      ...data
    })
  },
  getGroupDetail(data) {
    return get(url.getGroupDetail(data), {
      ...data
    })
  }
}